import { render } from "./PlaycanvasPlayer.vue?vue&type=template&id=4ef9bb6e&scoped=true"
import script from "./PlaycanvasPlayer.vue?vue&type=script&lang=js"
export * from "./PlaycanvasPlayer.vue?vue&type=script&lang=js"

import "./PlaycanvasPlayer.vue?vue&type=style&index=0&id=4ef9bb6e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef9bb6e"]])

export default __exports__